import request from '../plugins/axios'
// 合同添加
function ContractAdd (data) {
  return request({
    url: '/contract/add',
    method: 'post',
    data
  })
}
// 合同列表
function ContractList (data) {
  return request({
    url: '/contract/list',
    method: 'post',
    data
  })
}
//   合同详情
function ContractDetail (data) {
  return request({
    url: '/contract/detail',
    method: 'post',
    data
  })
}

//   编辑
function ContractEdit (data) {
  return request({
    url: '/contract/modify',
    method: 'post',
    data
  })
}
//   删除
function ContractDelete (data) {
  return request({
    url: '/contract/delete',
    method: 'post',
    data
  })
}
// 合同公司管理公司相关的接口：

// 增加公司
function ContractCompanyAdd (data) {
  return request({
    url: '/contract/company/add',
    method: 'post',
    data
  })
}

//   编辑
function ContractCompanyUpdate (data) {
  return request({
    url: '/contract/company/update',
    method: 'post',
    data
  })
}

//   列表
function ContractCompanyList (data) {
  return request({
    url: '/contract/company/list',
    method: 'post',
    data
  })
}

//   详情
function ContractCompanyDetail (data) {
  return request({
    url: '/contract/company/detail',
    method: 'post',
    data
  })
}
// 客户管理
// 添加
function customerAdd (data) {
  return request({
    url: '/customer/add',
    method: 'post',
    data
  })
}
// 编辑
function customerUpdate (data) {
  return request({
    url: '/customer/update',
    method: 'post',
    data
  })
}
// 详情
function customerDelete (data) {
  return request({
    url: '/customer/delete',
    method: 'post',
    data
  })
}

// 列表
function customerList (data) {
  return request({
    url: '/customer/list',
    method: 'post',
    data
  })
}
//详情
function customerDetail (data) {
  return request({
    url: '/customer/detail',
    method: 'post',
    data
  })
}
export {
  ContractAdd,
  ContractList,
  ContractDetail,
  ContractEdit,
  ContractDelete,

  ContractCompanyAdd,
  ContractCompanyUpdate,
  ContractCompanyList,
  ContractCompanyDetail,

  customerAdd,
  customerUpdate,
  customerDelete,
  customerList,
  customerDetail
}
